import React, { useState } from 'react';
import styled from 'react-emotion';
import ReactModal from 'react-modal';
import { ReactComponent as Cross } from '../../../svg/Cross.svg';
import Image from '@jetshop/ui/Image';
import { transparentDataImg } from '@jetshop/ui/Image/Image';
import Badges from '@jetshop/ui/ProductList/Badges';

const InformationPopupWrapper = styled('div')`
  border: 1px solid #000;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
  font-size: 14px;
  position: absolute;
  top: 6px;
  right: 6px;
`;

const InfoModalWrapper = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  pointer-events: none;
`;

const ModalInside = styled('div')`
  position: absolute;
  top: 190px;
  left: 0;
  right: 0;
  background: #fff;
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  padding: 2rem;
  border: 5px solid #000;

  svg.close-icon {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 20px;
    height: 20px;
    color: black;
    use,
    g,
    path {
      fill: black;
    }
  }

  .product-card {
    display: flex;
    flex-direction: column;

    .product-image-wrapper {
      width: 100%;
      max-width: 40%;
      margin: auto;
    }

    p {
      font-size: 14px;
    }
  }

  font-family: ${({ theme }) => theme.fonts.primary};

  p {
    margin-bottom: 1rem;
  }
  p a,
  p a:visited {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
  }

  h2,
  h3,
  h4 {
    text-align: center;
  }

  h2,
  h3,
  h4,
  strong,
  b {
    font-family: ${({ theme }) => theme.fonts.primary};
    text-transform: uppercase;
    letter-spacing: 0.08rem;
  }
  h2 {
    font-size: 1.6rem;
    margin-bottom: 1rem;
  }
  h3 {
    font-size: 1.2rem;
    margin-bottom: 1rem;
    ${({ theme }) => theme.below.lg} {
      font-size: 1rem;
    }
  }
  strong,
  b {
    font-weight: bold;
  }

  &:after {
    display: none;
  }
  img {
    max-width: 100%;
  }

  table {
    width: 100%;
    text-align: left;
    margin-bottom: 40px;
    p {
      margin: 0;
    }
    tr {
      background: #f3f3f3;
      &:nth-child(even) {
        background: white;
      }
      &:first-of-type {
        font-weight: 600;
      }
      th {
        padding: 5px;
        ${({ theme }) => theme.below.lg} {
          font-size: 12px;
        }
      }
      td {
        padding: 5px;
        ${({ theme }) => theme.below.lg} {
          font-size: 11px;
        }
      }
      td:first-of-type {
        width: 20%;
      }
    }
  }

  ${({ theme }) => theme.below.md} {
    top: unset;
    bottom: 0;
    padding: 1rem;
  }
`;

export const InformationPopup = ({ product }) => {
  const [open, setOpen] = useState(false);
  const hasImages = product.images && product.images.length > 0;

  return (
    <>
      <InformationPopupWrapper
        className="information"
        onClick={() => {
          setOpen(!open);
        }}
      >
        i
      </InformationPopupWrapper>
      <InfoModalWrapper
        isOpen={open}
        onRequestClose={() => {
          setOpen(false);
        }}
      >
        <ModalInside>
          <Cross
            className="close-icon"
            onClick={() => {
              setOpen(false);
            }}
          />
          <div className="product-card">
            <div className="product-image-wrapper">
              {hasImages ? (
                <Image
                  className="product-image"
                  sizes={'200px'}
                  aspect={'3:4'}
                  alt={product.images[0].alt}
                  src={product.images[0].url}
                >
                  <Badges badges={product.badges} />
                </Image>
              ) : (
                <Image
                  className="no-product-image product-image"
                  sizes={'200px'}
                  aspect={'3:4'}
                  src={transparentDataImg}
                />
              )}
            </div>
            <div>
              <h3>{product?.name}</h3>
              <p>{product?.shortDescription}</p>
            </div>
          </div>
        </ModalInside>
      </InfoModalWrapper>
    </>
  );
};
